import styled from 'styled-components'

import { Panel } from '@/ui/atoms/panel'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const ZeroResultsPanel = styled(Panel)`
  height: max-content;
  justify-content: center;
`

export const IconContainer = styled.div(
  ({ theme }) => `
  display: block;
  height: 18rem;
  margin-bottom: ${theme.spacing.default};
  width: 18rem;

  & svg {
    width: 18rem;
    height: 18rem;
  }
`
)

export const SearchTipsContainer = styled.div(
  ({ theme }) => `
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xLarge};
  margin: ${theme.spacing.large} 0 1rem 0;

  ${MEDIA_QUERIES(theme).large}{
    flex-direction: row;
  }
`
)
